<template>
  <div class="customerManage">
    <div class="header">
      <el-tabs :value="tabPaneValue" @tab-click="tabPaneClick">
        <el-tab-pane label="客户管理" name="first">
          <span class="activeLink">客户管理</span>
          <div class="btnBox">
            <div class="searchBtnBox" v-if="isMoreSearch">
              <el-tooltip
                class="item"
                content="清除查询条件"
                placement="bottom"
                :open-delay="300"
              >
                <el-button
                  icon="iconfont icon-qingkong"
                  size="small"
                  class="cleanBox"
                  @click="onClear"
                ></el-button>
              </el-tooltip>
              <el-button
                type="primary"
                icon="el-icon-search"
                size="small"
                @click="onSearch"
                >查询</el-button
              >
            </div>
            <el-button
              type="primary"
              icon="el-icon-plus"
              size="small"
              @click="addNewBtn"
              >新建</el-button
            >
            <el-tooltip
              class="item"
              content="查询条件"
              placement="bottom"
              :open-delay="300"
            >
              <el-button
                class="btn_more"
                :class="{ activeUserMore: isMoreSearch }"
                size="small"
                icon="el-icon-d-arrow-right"
                @click="moreSearchBtn"
              ></el-button>
            </el-tooltip>
          </div>
        </el-tab-pane>
        <el-tab-pane label="PID" name="second">
          <span class="activeLink">PID</span>
          <div class="btnBox">
            <div class="searchBtnBox" v-if="isMoreSearch">
              <el-tooltip
                class="item"
                content="清除查询条件"
                placement="bottom"
                :open-delay="300"
              >
                <el-button
                  icon="iconfont icon-qingkong"
                  size="small"
                  class="cleanBox"
                  @click="onClear"
                ></el-button>
              </el-tooltip>
              <el-button
                type="primary"
                icon="el-icon-search"
                size="small"
                @click="onSearch"
                >查询</el-button
              >
            </div>
            <el-button
              type="primary"
              icon="el-icon-download"
              size="small"
              @click="exportTuYaPid"
              >导出</el-button
            >
            <el-button
              type="primary"
              icon="el-icon-plus"
              size="small"
              @click="addTuYaPid"
              >新建</el-button
            >
            <el-tooltip
              class="item"
              content="查询条件"
              placement="bottom"
              :open-delay="300"
            >
              <el-button
                class="btn_more"
                :class="{ activeUserMore: isMoreSearch }"
                size="small"
                icon="el-icon-d-arrow-right"
                @click="moreSearchBtn"
              ></el-button>
            </el-tooltip>
          </div>
        </el-tab-pane>
        <el-tab-pane label="插件管理" name="pluginManage">
          <span
            v-for="(item, index) in pullDownData.pluginType"
            :key="index"
            class="childTabs"
            :class="{ activeLink: pluginType == item.code }"
            @click="pluginChange(item.code)"
            >{{ item.title }}</span
          >
          <div class="btnBox">
            <div class="searchBtnBox" v-if="isMoreSearch">
              <el-tooltip
                class="item"
                content="清除查询条件"
                placement="bottom"
                :open-delay="300"
              >
                <el-button
                  icon="iconfont icon-qingkong"
                  size="small"
                  class="cleanBox"
                  @click="onClear"
                ></el-button>
              </el-tooltip>
              <el-button
                type="primary"
                icon="el-icon-search"
                size="small"
                @click="onSearch"
                >查询</el-button
              >
            </div>
            <el-button
              type="primary"
              icon="el-icon-plus"
              size="small"
              @click="addPluginBtn"
              >添加</el-button
            >
            <el-tooltip
              class="item"
              content="查询条件"
              placement="bottom"
              :open-delay="300"
            >
              <el-button
                class="btn_more"
                :class="{ activeUserMore: isMoreSearch }"
                size="small"
                icon="el-icon-d-arrow-right"
                @click="moreSearchBtn"
              ></el-button>
            </el-tooltip>
          </div>
        </el-tab-pane>
      </el-tabs>
      <el-form
        :inline="true"
        :model="searchConditionForm"
        class="demo-form-inline"
        v-if="tabPaneValue == 'first' && isMoreSearch"
        :key="1"
      >
        <div class="searchConditionBox">
          <el-form-item label="客户名称" size="small">
            <el-input
              v-model="searchConditionForm.name"
              placeholder="客户名称"
              clearable
              @keyup.enter.native="getCustomerSearch()"
            ></el-input>
          </el-form-item>
          <el-form-item label="开始时间" size="small">
            <el-date-picker
              v-model="searchConditionForm.startDate"
              type="date"
              placeholder="下单统计开始时间"
              value-format="yyyy-MM-dd"
              @change="startDateChange"
              :picker-options="$store.state.pickerOptions"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="结束时间" size="small">
            <el-date-picker
              v-model="searchConditionForm.endDate"
              type="date"
              placeholder="下单统计结束时间"
              @change="endDateChange"
              value-format="yyyy-MM-dd"
              :picker-options="$store.state.pickerOptions"
            ></el-date-picker>
          </el-form-item>
        </div>
      </el-form>
      <el-form
        :inline="true"
        :model="tuYaSearchForm"
        class="demo-form-inline"
        v-if="tabPaneValue == 'second' && isMoreSearch"
        :key="2"
      >
        <div class="searchConditionBox">
          <el-form-item label="客户" size="small">
            <el-select
              v-model="tuYaSearchForm.customerId"
              placeholder="选择客户名称"
              filterable
              clearable
            >
              <el-option
                v-for="(item, index) in pullDownData.customerList"
                :key="index"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="产品型号" size="small">
            <el-select
              v-model="tuYaSearchForm.productId"
              placeholder="选择产品型号"
              filterable
              clearable
            >
              <el-option
                v-for="(item, index) in pullDownData.tuYaProductList"
                :key="index"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="PID" size="small">
            <el-input
              v-model="tuYaSearchForm.tuyaPid"
              placeholder="暂只支持自定义PID"
              clearable
              @keyup.enter.native="$refs.tuYaPage.getCustomerPidSearch()"
            ></el-input>
          </el-form-item>
          <el-form-item label="业务员" size="small">
            <el-input
              v-model="tuYaSearchForm.sales"
              placeholder="如：张三"
              clearable
              @keyup.enter.native="$refs.tuYaPage.getCustomerPidSearch()"
            ></el-input>
          </el-form-item>
          <el-form-item label="注册名称" size="small">
            <el-input
              v-model="tuYaSearchForm.productName"
              placeholder="涂鸦IoT平台注册的名称"
              clearable
              @keyup.enter.native="$refs.tuYaPage.getCustomerPidSearch()"
            ></el-input>
          </el-form-item>
          <el-form-item label="开发者" size="small">
            <el-input
              v-model="tuYaSearchForm.master"
              placeholder="涂鸦IoT平台归属的帐号"
              clearable
              @keyup.enter.native="$refs.tuYaPage.getCustomerPidSearch()"
            ></el-input>
          </el-form-item>
        </div>
      </el-form>
      <el-form
        :inline="true"
        :model="pluginSearchForm"
        class="demo-form-inline"
        v-if="tabPaneValue == 'pluginManage' && isMoreSearch"
        :key="3"
      >
        <div class="searchConditionBox">
          <el-form-item label="客户" size="small" prop="customerId">
            <el-select
              v-model="pluginSearchForm.customerId"
              placeholder="选择客户名称"
              filterable
              clearable
            >
              <el-option
                v-for="(item, index) in pullDownData.customerList"
                :key="index"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="产品类别" size="small">
            <el-select
              v-model="pluginSearchForm.productType"
              placeholder="选择产品类别"
              filterable
              clearable
              @change="productTypeChange"
            >
              <el-option
                v-for="(item, index) in pullDownData.productTypeList"
                :key="index"
                :label="item.title"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="产品型号" size="small">
            <el-select
              v-model="pluginSearchForm.productId"
              placeholder="选择产品型号"
              filterable
              clearable
            >
              <el-option
                v-for="(item, index) in pullDownData.searchProductList"
                :key="index"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="插件名称" size="small">
            <el-select
              v-model="pluginSearchForm.bean"
              placeholder="选择插件名称"
              filterable
              clearable
            >
              <el-option
                v-for="(item, index) in pullDownData.pluginList"
                :key="index"
                :label="item.title"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <div class="contentBox">
      <div class="rightContent" v-if="tabPaneValue == 'first'">
        <el-table
          stripe
          :data="tableData"
          border
          style="width: 100%"
          height="100%"
          size="mini"
          @sort-change="sortChange"
        >
          <el-table-column
            type="index"
            :width="pagination.endIndex >= 1000 ? 80 : 50"
            align="center"
            :index="pagination.beginIndex"
          ></el-table-column>
          <el-table-column
            prop="name"
            label="客户名称"
            min-width="150"
            align="center"
            show-overflow-tooltip
            sortable="custom"
          >
            <template slot-scope="scope">
              <span class="allowSkip" @click="editCustomeInfo($event, scope.row)">{{
                scope.row.name
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="shortName"
            label="客户简称"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span v-if="scope.row.shortName">{{ scope.row.shortName }}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="code"
            label="客户代码"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span v-if="scope.row.code">{{ scope.row.code }}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>          
          <el-table-column
            prop="orderCount"
            label="订单数量(单)"
            align="center"
            min-width="110px"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="productCount"
            label="下单数量(PCS)"
            align="center"
            min-width="110px"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="notes"
            label="备注"
            align="center"
            min-width="110px"
            show-overflow-tooltip
          ></el-table-column>
        </el-table>
        <pagination
          :pagination="pagination"
          @currentChange="currentChange"
          @sizeChange="sizeChange"
          @refreshBtn="getCustomerSearch"
        ></pagination>
      </div>
      <div class="rightContent" v-else-if="tabPaneValue == 'second'">
        <tuYaPage ref="tuYaPage" :tuYaSearchForm="tuYaSearchForm"></tuYaPage>
      </div>
      <div class="rightContent" v-else-if="tabPaneValue == 'pluginManage'">
        <pluginPage
          ref="pluginPage"
          :pluginType="pluginType"
          :pluginSearchForm="pluginSearchForm"
        ></pluginPage>
      </div>
    </div>
    <myDialog
      ref="myDialog"
      :title="dialogTitle"
      @submitData="submitData"
      @dialogClose="dialogClose"
      width="410px"
    >
      <template slot="content">
        <el-form
          ref="dialogForm"
          :model="dialogForm"
          :rules="dialogRules"
          :label-width="labelWidth"
        >
          <el-form-item label="客户名称：" size="small" prop="name">
            <el-input
              v-model="dialogForm.name"
              placeholder="请输入客户名称"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="客户简称：" size="small" prop="shortName">
            <el-input
              v-model="dialogForm.shortName"
              placeholder="请输入客户简称"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="客户代码：" size="small" prop="code">
            <el-input
              v-model="dialogForm.code"
              placeholder="请输入客户代码"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="备注：" size="small" prop="code">
            <el-input
              v-model="dialogForm.notes"
              placeholder="请输入备注信息，如：SN长度"
              clearable
            ></el-input>
          </el-form-item>
          <!-- <div class="importBox">
            <el-checkbox v-model="dialogForm.importSn">客户提供SN</el-checkbox>
            <el-checkbox v-model="dialogForm.importMac">客户提供MAC</el-checkbox>
            <el-checkbox v-model="dialogForm.importUuid">客户提供UUID</el-checkbox>
          </div> -->
        </el-form>
      </template>
    </myDialog>
  </div>
</template>

<script>
import pagination from "@/components/pagination.vue";
import myDialog from "@/components/myDialog.vue";
import tuYaPage from "./components/tuYaPage.vue";
import pluginPage from "./components/pluginPage.vue";
import {
  apiCustomerSearch,
  apiCustomerAdd,
  apiCustomerUpdate,
  apiCustomerList,
  apiProductTypeList,
  apiProductList,
  apiCustomerPluginType,
  apiCustomerPluginList,
} from "@/api/customerManage.js";
export default {
  lastModuleConfig: { modulePath: "/homePage/customerManage", topTabVar: "tabPaneValue", topTabs: ["first", "second", "pluginManage"] },
  components: {
    pagination,
    myDialog,
    tuYaPage,
    pluginPage,
  },
  data() {
    return {
      tabPaneValue: "first",
      pluginType: "",
      isMoreSearch: false,
      searchConditionForm: {},
      tuYaSearchForm: {},
      pluginSearchForm: {},
      pullDownData: {
        customerList: [],
        tuYaProductList: [],
        pluginType: [],
        pluginList: [],
        productTypeList: [],
        searchProductList: [],
        addProductList: [],
      },
      tableData: [],
      desc: undefined,
      orderBy: [],
      pagination: {
        currentPage: 1,
        pageSize: 40,
        total: 102,
        beginIndex: 1,
        endIndex: 10,
      },
      dialogTitle: "",
      dialogForm: {
        importSn: false,
        importMac: false,
        // importUuid: false,
      },
      dialogRules: {
        name: [
          { required: true, message: "名称不能为空！", trigger: "blur" },
          {
            min: 2,
            max: 128,
            message: "长度在 2 到 128 个字符",
            trigger: "change",
          },
        ],
      },
      labelWidth: this.$store.state.labelWidth,
    };
  },
  watch: {
    tabPaneValue: function (newVal) {
      this.$moreSearchStyle();
      if (newVal == "first") {
        this.getCustomerSearch();
      } else if (newVal == "second") {
        this.$nextTick(() => {
          this.$refs.tuYaPage.getCustomerPidSearch();
        });
      } else if (newVal == "pluginManage") {
        this.$nextTick(() => {
          this.$refs.pluginPage.getCustomerPluginSearch();
        });
      }
    },
  },
  methods: {
    // 切换一级面板
    tabPaneClick(tab) {
      this.tabPaneValue = tab.name;
    },
    // 切换插件管理子标签
    pluginChange(value) {
      this.pluginType = value;
      this.$set(this.pluginSearchForm, "bean", undefined);
      this.$nextTick(() => {
        this.$refs.pluginPage.getCustomerPluginSearch("", this.getPluginList);
      });
    },
    // 客户表格数据
    async getCustomerSearch(remove, callback) {
      if (remove != "noRemove") {
        this.tableData = [];
      }
      const res = await apiCustomerSearch({
        ...this.searchConditionForm,
        pageNum: this.pagination.currentPage,
        pageSize: this.pagination.pageSize,
        desc: this.desc,
        orderBy: this.orderBy,
      });
      // console.log(res);
      if (res.code == 0) {
        this.tableData = res.data;
        this.pagination.total = res.total;
        this.pagination.beginIndex = res.beginIndex;
        this.pagination.endIndex = res.endIndex;
        if (callback) callback();
      }
    },
    // 更多查询
    moreSearchBtn() {
      this.isMoreSearch = !this.isMoreSearch;
      this.$moreSearchStyle();
    },
    // 添加客户
    addNewBtn() {
      this.dialogTitle = "新建客户";
      this.$refs.myDialog.dialogVisible = true;
    },
    // 修改客户
    editCustomeInfo(e, row) {
      e.target.blur();
      this.dialogTitle = "修改客户";
      this.$refs.myDialog.dialogVisible = true;
      this.dialogForm = {
        ...row
      }
    },
    // 确认添加
    submitData(title) {
      this.$refs.dialogForm.validate(async (valid) => {
        if (valid) {
          let res = {};
          if (title == "新建客户") {
            res = await apiCustomerAdd({
              ...this.dialogForm,
            });
            if (res.code == 0) {
              this.$refs.myDialog.dialogVisible = false;
              this.pagination.currentPage = 1;
              this.getCustomerSearch();
              this.$message({
                message: "新建成功",
                type: "success",
              });
              // 重新获取客户下拉
              this.getCustomerList();
            }
          } else if(title == "修改客户") {
            res = await apiCustomerUpdate({
              ...this.dialogForm,
            })
            if(res.code == 0) {
              this.$refs.myDialog.dialogVisible = false;
              this.getCustomerSearch("noRemove");
              this.$message({
                message: "修改成功",
                type: "success",
              });
              // 重新获取客户下拉
              this.getCustomerList();
            }
          }
        } else {
          return false;
        }
      });
    },
    // 关闭对话框
    dialogClose() {
      this.$refs.dialogForm.resetFields();
      this.dialogForm = {
        importSn: false,
        importMac: false,
        // importUuid: false,
      };
    },
    // 清除查询
    onClear() {
      if (this.tabPaneValue == "first") {
        this.pagination.currentPage = 1;
        this.searchConditionForm = {};
        this.getCustomerSearch();
      } else if (this.tabPaneValue == "second") {
        this.$refs.tuYaPage.pagination.currentPage = 1;
        this.tuYaSearchForm = {};
        this.$nextTick(() => {
          this.$refs.tuYaPage.getCustomerPidSearch();
        });
      } else if (this.tabPaneValue == "pluginManage") {
        this.pullDownData.searchProductList = [];
        this.$refs.pluginPage.pagination.currentPage = 1;
        this.pluginSearchForm = {};
        this.$nextTick(() => {
          this.$refs.pluginPage.getCustomerPluginSearch();
        });
      }
    },
    // 确认查询
    onSearch() {
      if (this.tabPaneValue == "first") {
        this.pagination.currentPage = 1;
        this.getCustomerSearch();
      } else if (this.tabPaneValue == "second") {
        this.$refs.tuYaPage.pagination.currentPage = 1;
        this.$refs.tuYaPage.getCustomerPidSearch();
      } else if (this.tabPaneValue == "pluginManage") {
        this.$refs.pluginPage.pagination.currentPage = 1;
        this.$refs.pluginPage.getCustomerPluginSearch();
      }
    },
    // 下单开始时间
    startDateChange() {
      let { startDate, endDate } = this.searchConditionForm;
      if (startDate > endDate) {
        this.searchConditionForm.endDate = this.searchConditionForm.startDate;
      }
    },
    // 下单结束时间
    endDateChange() {
      let { startDate, endDate } = this.searchConditionForm;
      if (startDate > endDate) {
        this.searchConditionForm.startDate = this.searchConditionForm.endDate;
      }
    },
    // 输出报表点击
    exportReport(row) {
      console.log(row);
      const h = this.$createElement;
      return this.$notify({
        title: "操作详情",
        message: h("div", null, [
          h("div", null, [
            h("span", null, "报表插件："),
            h("span", null, `${row.uploadPlugIn?row.uploadPlugIn: "-"}`),
          ]),
          h("div", null, [
            h("span", null, "报表类型："),
            h("span", null, `${row.uploadType?row.uploadType:"-"}`),
          ]),
        ]),
        customClass: "exportReportDetail",
      });
    },
    // 表格数据排序
    sortChange({ prop, order }) {
      this.orderBy[0] = prop;
      if (order == "ascending") {
        this.desc = false;
      } else if (order == "descending") {
        this.desc = true;
      } else {
        this.desc = undefined;
        this.orderBy = [];
      }
      this.getCustomerSearch();
    },
    // 页码改变
    currentChange(val) {
      this.pagination.currentPage = val;
      this.getCustomerSearch();
    },
    // 页容量改变
    sizeChange(val) {
      this.pagination.currentPage = 1;
      this.pagination.pageSize = val;
      this.getCustomerSearch();
    },
    // 产品类别改变
    productTypeChange(value) {
      this.$set(this.pluginSearchForm, "productId", undefined);
      this.pullDownData.searchProductList = [];
      if (value) {
        this.getProductList(value, "searchProductList");
      }
    },
    // 添加涂鸦PID
    addTuYaPid() {
      this.$refs.tuYaPage.addTuYaPid();
    },
    // 导出涂鸦PID
    exportTuYaPid() {
      this.$refs.tuYaPage.exportTuYaPid();
    },
    // 添加客户插件
    addPluginBtn() {
      this.$refs.pluginPage.addPlugin();
    },
    // 客户名称下拉
    async getCustomerList() {
      const res = await apiCustomerList();
      if (res.code == 0) {
        this.pullDownData.customerList = res.data;
      }
    },
    // 涂鸦产品列表
    async getTuYaProductList() {
      const res = await apiProductList({
        productType: "IPC",
        p2pType: ["TUYA", "LinkView", "LinkViewByWakeUp"],
      });
      if (res.code == 0) {
        this.pullDownData.tuYaProductList = res.data;
      }
    },
    // 插件类别
    async getPluginType() {
      const res = await apiCustomerPluginType();
      if (res.code == 0) {
        this.pullDownData.pluginType = res.data;
        if (!this.pluginType) this.pluginType = res.data[0].code;
        this.getPluginList();
      }
    },
    // 插件名称列表
    async getPluginList() {
      const res = await apiCustomerPluginList({
        type: this.pluginType,
      });
      if (res.code == 0) {
        this.pullDownData.pluginList = res.data;
      }
    },
    // 产品类别下拉
    async getProductTypeList() {
      const res = await apiProductTypeList();
      if (res.code == 0) {
        this.pullDownData.productTypeList = res.data;
      }
    },
    // 产品型号下拉
    async getProductList(productType, name) {
      const res = await apiProductList({
        productType
      });
      if (res.code == 0) {
        this.pullDownData[name] = res.data;
      }
    },
    callback() {
      this.getCustomerList();
      this.getTuYaProductList();
      this.getPluginType();
      this.getProductTypeList();
    },
  },
  activated() {
    window.onresize = () => {
      document.querySelector(".contentBox").style.top =
        document.querySelector(".header").offsetHeight + "px";
    };
    if (this.tabPaneValue == "first") {
      this.getCustomerSearch("", this.callback);
    } else if (this.tabPaneValue == "second") {
      this.$refs.tuYaPage.getCustomerPidSearch("", this.callback);
    } else if (this.tabPaneValue == "pluginManage") {
      this.$refs.pluginPage.getCustomerPluginSearch("", this.callback);
    }
  },
  deactivated() {
    window.onresize = null;
  },
};
</script>

<style lang="less" scoped>
.importBox {
  height: 33px;
  line-height: 33px;
  margin-bottom: 16px;
  /deep/.el-checkbox {
    margin-right: 10px;
  }
  /deep/.el-checkbox:last-child {
    margin-right: 0px;
  }
}
</style>